(() => {
  const pending = window.ArabEyesQueue || [];
  const jobs = new Map();
  const start = root => {
    const init = jobs.get(root);
    if (!init) return;
    jobs.delete(root);
    observer?.unobserve(root);
    if (root.isConnected) init();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) start(entry.target); });
  }, { rootMargin: '200px 0px' }) : null;
  const register = job => {
    const root = document.getElementById(job.id);
    if (!root) return;
    jobs.set(root, job.init);
    if (observer) observer.observe(root); else start(root);
  };
  window.ArabEyesQueue = { push: register };
  pending.forEach(register);
  document.addEventListener('click', event => {
    const play = event.target.closest('[data-review-play]');
    const reviews = play?.closest('ae-community-reviews');
    if (reviews && !reviews.ready) reviews._aePendingPlay = play;
    const opener = event.target.closest('[data-open-options]');
    const section = opener?.closest('.ae-products-section');
    if (section && section.dataset.sliderReady !== 'true') section._aePendingOpener = opener;
  }, true);
  ['pointerdown', 'focusin', 'click'].forEach(type => document.addEventListener(type, event => {
    jobs.forEach((init, root) => { if (root.contains(event.target)) start(root); });
  }, { capture: true, passive: true }));
  document.addEventListener('shopify:section:unload', event => {
    jobs.forEach((init, root) => {
      if (event.target.contains(root)) { observer?.unobserve(root); jobs.delete(root); }
    });
  });
  const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('ae-in-view', entry.isIntersecting));
  }) : null;
  const observeMotion = scope => scope.querySelectorAll('.ae-hero, .ae-footer, .ae-statement').forEach(el => {
    if (visibility) visibility.observe(el); else el.classList.add('ae-in-view');
  });
  observeMotion(document);
  document.addEventListener('shopify:section:load', e => observeMotion(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.ae-hero, .ae-footer, .ae-statement').forEach(el => visibility?.unobserve(el));
  });
})();
